import style from './pages.module.css'

export function MoreIcon({ isOpen }: { isOpen: boolean }) {
  return <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={[
      style.accordionIcon,
      isOpen ? style.isOpen : '',
    ].join(' ')}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7.80005 12.3923L14.3441 5.84817C14.6956 5.4967 15.2655 5.4967 15.6169 5.84817C15.9684 6.19964 15.9684 6.76949 15.6169 7.12096L10.3456 12.3923L15.6169 17.6636C15.9684 18.015 15.9684 18.5849 15.6169 18.9363C15.2655 19.2878 14.6956 19.2878 14.3441 18.9363L7.80005 12.3923Z'
      fill='#6B6B6B'
    />
  </svg>
}
